import React from 'react';

import MuiHidden, { HiddenProps as MuiHiddenProps } from '@mui/material/Hidden';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Hidden = withCoreProps<HiddenProps>((props) => {
  const { children, ...otherProps } = props;

  return <MuiHidden {...otherProps}>{children}</MuiHidden>;
});

export type HiddenProps = MuiHiddenProps &
  CoreProps & { children?: React.ReactNode };
